import { AxiosPromise } from 'axios';
import attendeeFixedCost, {
  AttendeeFixedCost,
} from '../model/attendeeFixedCost';
import { instance, URLS } from '.';

export interface BackendAttendeeFixedCost {
  getAttendeeFixedCosts(
    attendeeId: string,
    discountDate?: string
  ): AxiosPromise<AttendeeFixedCost[]>;
  getAttendeeFixedCostsByApplicationUserId(
    applicationUserId: string,
    discountDate?: string
  ): AxiosPromise<AttendeeFixedCost[]>;
  postMultipleAttendeeFixedCosts(
    attendeeFixedCosts: AttendeeFixedCost[]
  ): AxiosPromise;
}

export const defaultBackendAttendeeFixedCost: BackendAttendeeFixedCost = {
  getAttendeeFixedCosts(
    attendeeId: string,
    discountDate?: string
  ): AxiosPromise<AttendeeFixedCost[]> {
    const url = `${URLS.attendeeFixedCosts}/GetByAttendeeId/${attendeeId}`;
    return instance.get<AttendeeFixedCost[]>(url, {
      params: { discountDate: discountDate },
    });
  },
  getAttendeeFixedCostsByApplicationUserId(
    applicationUserId: string,
    discountDate?: string
  ): AxiosPromise<AttendeeFixedCost[]> {
    const url = `${URLS.attendeeFixedCosts}/GetByApplicationUserId/${applicationUserId}`;
    return instance.get<AttendeeFixedCost[]>(url, {
      params: { discountDate: discountDate },
    });
  },
  postMultipleAttendeeFixedCosts(
    attendeeFixedCosts: AttendeeFixedCost[]
  ): AxiosPromise {
    const url = `${URLS.attendeeFixedCosts}/AddMultiple`;
    return instance.post(url, {
      AttendeeFixedCosts: attendeeFixedCosts.map(attendeeFixedCost.toAPI),
    });
  },
};
